import { selectRolesViewModel } from "@/features/management-settings/view-models/select-roles-view-model";
import { Button } from "@spz/ui/components/button";
import { SearchBar } from "@spz/ui/components/search-bar";
import { DataTable } from "@spz/ui/components/table/data-table";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import { TableFooter } from "../../shared/components/table-footer";

const RolesTab: FC = () => {
  const { t } = useTranslation();

  const {
    columns,
    roles,
    isLoading,
    createRoleDialog,
    currentPage,
    pageSize,
    totalPages,
    handlePageChange,
    handlePageSizeChange,
    setSearchQuery,
    hasRolesManagementPermission,
  } = selectRolesViewModel();

  if (!hasRolesManagementPermission) {
    return <Navigate to="/403" replace />;
  }

  return (
    <>
      <div className="flex justify-between mb-4">
        <div className="w-1/2 max-w-[344px]">
          <SearchBar
            onSearch={setSearchQuery}
            placeholder={t("search_role_placeholder")}
          />
        </div>
        <Button onClick={() => createRoleDialog.open()}>
          {t("create_new_role")}
        </Button>
      </div>
      <DataTable columns={columns} data={roles.data} isLoading={isLoading} />
      <TableFooter
        currentPage={currentPage}
        totalPages={totalPages}
        pageSize={pageSize}
        totalCount={roles.total}
        isLoading={isLoading}
        entityLabel="pagination_entity_roles"
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </>
  );
};

export default RolesTab;
